export default __webpack_public_path__ + "static/media/close-button.75f74d05.svg";